import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'

export function requestBodySanitizationInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  let sanitized = sanitizeQueryVars(req.body)
  let clone = req.clone({ body: sanitized })
  return next(clone)
}

/**
   * Sanitize the `queryVars` property of the body. Replaces all instances
   * of empty strings with `NULL`.
   *
   * @param body  The body of the intercepted HTTP request
   *
   * @return      Returns a modified instance of the body that has been sanitized
   */
function sanitizeQueryVars<T>(body: T): T {
  if (body && typeof body === 'object' && 'queryVars' in body && typeof body?.queryVars === 'object') {
    body.queryVars = sanitizeObject(body.queryVars)
  }

  return body
}

function sanitizeObject(object: object): object {
  for (let key in object) {
    if (object[key] instanceof Object) {
      object[key] = sanitizeObject(object[key])
    } else {
      object[key] = object[key] === '' ? null : object[key]
    }
  }

  return object
}
